module.exports = __webpack_public_path__ + "img/logo.ea7e34c9.png";